import styled from 'styled-components';
import { Form, FormProps } from 'antd';
import { CustomThemeToken } from '@/theme/theme.utils';

export const StyledStage = styled(Form)<{ theme: { token: CustomThemeToken } & FormProps, $isBlocked: boolean }>`
    display: flex;
    padding: 0 ${({ theme: { token } }) => token.marginLG}px ${({ theme: { token } }) => token.marginLG}px;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme: { token } }) => token.marginLG}px;
    background: ${({ theme: { token } }) => token.colorBgContainer};
    width: 100%;
    gap: ${({ theme: { token } }) => token.marginLG}px;
    border-radius: 0 0 ${({ theme: { token } }) => token.borderRadiusLG}px ${({ theme: { token } }) => token.borderRadiusLG}px;
    .tasks-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
        border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
        & > :last-child {
            border-bottom: none;
        }
        .due-date-progress-section {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: ${({ theme: { token } }) => token.margin}px;
            padding: ${({ theme: { token } }) => token.margin}px;
            border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
            .due-date-label-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                gap: ${({ theme: { token } }) => token.paddingXXS}px;
                .due-date-label {
                    font-size: ${({ theme: { token } }) => token.fontSize}px;
                    color: ${({ theme: { token } }) => token.colorTextDescription};
                }
                .timer-container {
                    display: flex;
                    align-items: center;
                    gap: ${({ theme: { token } }) => token.marginSM}px;
                    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
                    color: ${({ theme: { token } }) => token.colorTextHeading};
                    .timer-icon {
                        color: ${({ theme: { token } }) => token.colorWarning};
                    }
                    .timer-icon-passed {
                        color: ${({ theme: { token } }) => token.colorError};
                    }
                    .timer-value {
                        transform: translateY(2px);
                        color: ${({ theme: { token } }) => token.colorTextHeading};
                    }
                }
            }
            .due-date-progress-container {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: ${({ theme: { token } }) => token.marginLG}px;
                .ant-progress {
                    max-width: 247px;
                }
                span {
                    text-align: center;
                    font-size: ${({ theme: { token } }) => token.fontSize}px;
                    color: ${({ theme: { token } }) => token.colorText};
                }
            }
        }
        .user-ids-section {
            display: flex;
            flex-direction: row;
            gap: ${({ theme }) => theme.token.paddingLG}px;
            padding-top: ${({ theme }) => theme.token.padding}px;
            flex-wrap: wrap;
            padding-inline: ${({ theme }) => theme.token.padding}px;
            width: 100%;
        }
    }
    .stage-cta-container {
        display: flex;
        padding-inline: ${({ theme: { token } }) => token.paddingLG}px;
        gap: ${({ theme: { token } }) => token.paddingLG}px;
    }
    .block-button {
        color: ${({ theme: { token }, $isBlocked }) => $isBlocked ? token.colorError : token.colorPrimary};
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${({ theme: { token } }) => token.padding}px;
        border: 1px solid ${({ theme: { token }, $isBlocked }) => $isBlocked ? token.colorError : token.colorPrimary};
        &:hover {
            color: ${({ theme: { token }, $isBlocked }) => $isBlocked ? token.colorErrorHover : token.colorPrimaryHover};
            border: 1px solid ${({ theme: { token }, $isBlocked }) => $isBlocked ? token.colorErrorHover : token.colorPrimaryHover};
        }
    }
`;
